import { normalizeLawFirmOption } from "./normalizers";

export const extractActingUser = (actionItem) => {
  if (!actionItem) {
    return null;
  }

  if (actionItem?.actingUserName) {
    return {
      id: actionItem?.actingUserId,
      name: actionItem?.actingUserName,
    };
  }

  if (actionItem?.actingUser || actionItem?.acting_user) {
    return {
      id:
        actionItem?.actingUser?.pk ??
        actionItem?.actingUser?.id ??
        actionItem?.acting_user?.pk ??
        actionItem?.acting_user?.id,
      name: actionItem?.actingUser?.name ?? actionItem?.acting_user?.name ?? "",
    };
  }

  return null;
};

export const extractCase = (actionItem) => {
  if (!actionItem) {
    return null;
  }

  if (actionItem?.onCaseId) {
    return {
      pk: actionItem?.onCaseId,
      id: actionItem?.onCaseId,
      client: { name: actionItem?.onCaseName ?? "" },
      name: actionItem?.onCaseName ?? "",
    };
  }

  const pk =
    actionItem?.onCase?.pk ??
    actionItem?.onCase?.id ??
    actionItem?.on_case?.pk ??
    actionItem?.on_case?.id;

  return {
    pk,
    id: pk,
    name: actionItem?.onCase?.name ?? actionItem?.on_case?.name ?? "",
    client: {
      name: actionItem?.onCase?.client?.name ?? actionItem?.on_case?.client?.name ?? "",
    },
  };
};

export const extractDetail = (actionItem) => {
  if (!actionItem) {
    return "";
  }

  if (actionItem?.shortDescription) {
    return actionItem?.shortDescription ?? "";
  }

  return actionItem?.actionDetail ?? actionItem?.action_detail ?? "";
};

export const extractProvider = (actionItem) => {
  if (!actionItem) {
    return null;
  }

  if (actionItem?.onProviderId) {
    return {
      id: actionItem?.onProviderId,
      label: actionItem?.onProviderName,
    };
  }

  if (actionItem?.onProvider || actionItem?.on_provider) {
    return {
      id:
        actionItem?.onProvider?.pk ??
        actionItem?.onProvider?.id ??
        actionItem?.on_provider?.pk ??
        actionItem?.on_provider?.id,
      label:
        actionItem?.onProvider?.name ??
        actionItem?.on_provider?.name ??
        actionItem?.onProviderName ??
        "",
    };
  }

  return null;
};

export const extractLawFirmInfo = (actionItem) => {
  const hasLawFirmAccess = !!(
    actionItem?.onFirm?.id ||
    actionItem?.onFirm?.pk ||
    actionItem?.on_firm?.pk ||
    actionItem?.onLawFirmId ||
    actionItem?.onFirmId
  );

  if (!hasLawFirmAccess) {
    return {
      hasLawFirmAccess,
      normalizedLawFirm: null,
    };
  }

  const lawFirmOption = {
    id:
      actionItem?.onFirm?.pk ??
      actionItem?.onFirm?.id ??
      actionItem?.on_firm?.pk ??
      actionItem?.onLawFirmId ??
      actionItem?.onFirmId,
    label: actionItem?.onFirm?.name ?? actionItem?.on_firm?.name ?? actionItem?.onFirmName ?? "",
  };

  return {
    hasLawFirmAccess,
    normalizedLawFirm: normalizeLawFirmOption(lawFirmOption),
  };
};
